// Module
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useEffect, useRef, useState } from 'react';
import dompurify from "dompurify";

// CSS
import '_Asset/css/User/Page/main.css'

// Component
import { PostList } from 'User/Component';
import { menuList_2 } from 'User/Component/MenuList';

// API
import { NewsListApi } from '_Route/Api';


const Main = () => {

  // Hooks
  const { t } = useTranslation();
  const sanitizer = dompurify.sanitize;
  const navigate = useNavigate();

  const [newsData, setNewsData] = useState([]);
  
  useEffect(() => {
    axios.get(NewsListApi)
    .then(res => {
      setNewsData(res.data.result)
    })
    .catch(err => {
      console.error(err, "ERROR...")
    })
  }, [])
  
  const newsLimit = 12; // 노출 News 갯수
  const curNews = newsData.filter((key, i) => i < newsLimit) // 최근 News 3개
  const postGroupRef = useRef(null);
  let heightArr = [];

  const postItem = [
    {target: '_self', class: 'apis', url: "/develop/apis-manual", title: "APIs Manual"},
    {target: '_self', class: 'ui', url: "/design/ui-components", title: "UI Components"},
    {target: '_self', class: 'recruit', url: "/addition/developer-employ", title: "Seyfert Recruit"},
    {target: '_blank', class: 'aml', url: "https://aml.paygate.net", title: "AML Portal"},
    {target: '_blank', class: 'members', url: "https://member.seyfert.kr", title: "Seyfert Members"},
  ]

  // 콘텐츠 페이지 검색
  const [searchVal, setSearchVal] = useState();

  // Search Input Value Setting
  const onKeyPress = (e) => { if(e.key == 'Enter') onSearch(); }
  const onSearch = () => {
    // navigate(searchMenu[0].path);
    if (searchVal.length < 2) {
      alert("검색어를 두글자 이상 입력해주세요.")
    } else {
      navigate(`/develop/apis-manual/search/${encodeURIComponent(searchVal)}`);
    }
  }
  

  return (
    <>
      {/* Visual */}
      <div className="visual main">
        <div className="section">
          <div className="visualTitGroup">
            {/* <h2 className="visualTit">{t('main_visual_tit')}</h2> */}
            <h2 className="visualTit">Discover and create with Seyfert Developers</h2>
            {/* <p dangerouslySetInnerHTML={{ __html: sanitizer(t('main_visual_txt')) }} className="visualTxt"></p> */}
            <p dangerouslySetInnerHTML={{ __html: sanitizer('Using our tools and service, you can provide an exceptional exprerience to Seyfert<br />Users around the world')}} className="visualTxt"></p>
          </div>

          <fieldset>
            <legend>콘텐츠 검색</legend>

            <div className="fieldGroup row mainSearch">
              <div className="field">
                {/* <input type="input" className="input lg" placeholder={t('main_visual_input_placeholder')} onChange={(e) => setSearchVal(e.target.value)} onFocus={() => searchVal ? setIsFocus(true) : ''} onKeyUp={() => searchVal ? setIsFocus(true) : ''} onBlur={() => setIsFocus(false)} onKeyPress={onKeyPress}/> */}
                <input type="input" className="input lg" placeholder='검색할 콘텐츠를 입력해주세요.' onChange={(e) => setSearchVal(e.target.value)} onKeyPress={onKeyPress}/* onFocus={() => searchVal ? setIsFocus(true) : ''} onKeyUp={() => searchVal ? setIsFocus(true) : ''} onBlur={() => setIsFocus(false)} *//>
                <button type="button" className="btn md sfrtBlue i_only" onClick={onSearch}><i className="icofont-search"></i></button>
                {/* 
                <ul className={isFocus && searchVal !== '' ? 'active' : ''}>
                  {
                    searchMenu.length !== 0 ?
                    searchMenu.map((key, i) => 
                      <li key={i}>
                        <Link to={key.path}>
                          <i className={key.icon ? key.icon : 'icofont-search'} style={{backgroundColor: `var(--${key.color})`}}></i>
                          <p>
                            {searchArr[i].map((text, i) => 
                              text.toLowerCase().trim() === searchVal.toLowerCase().trim() ?
                              <span key={i}>{text}</span>
                              :
                              text
                            )}
                          </p>
                        </Link>
                      </li>
                    )
                    :
                    <div className="noDataBox">
                      <i className="icofont-warning-alt"></i>
                      <p><span>{searchVal}</span>로 검색된 결과가 존재하지 않습니다.<br /> Please enter another search term.</p>
                    </div>
                  }
                </ul> */}
              </div>
            </div>
          </fieldset>
        </div>
      </div>

      <div className="mainContents">
        {/* Main Nav Content */}
        <div className="navArea areaBoxMain">
          <div className="section">
            <div className="navGroup">
              {postItem.map((item, i) =>
                <div className={`navItem ${i > 1 ? 'type_02' : ''} ${item.class}`} key={i}>
                  <p>{item.title}</p>

                  {item.target === '_blank' ?
                    <a href={item.url} target="_blank" title="새창에서 열림"></a>
                    :
                    <Link to={item.url}></Link>
                  }
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Latest News Content */}
        <div className="mainNewsArea areaBoxMain">
          <div className="section">
            <div className="contTitGroup">
              <div className="contTitRow">
                <h2 className="contTit">Latest News</h2>
                
                <Link to="/connect/news">GO TO NEWS <i className="icofont-rounded-right"></i></Link>
              </div>

              <p className="contMsg">Find in-technical content written by developers</p>
            </div>

            <div className="postGroup" ref={postGroupRef}>
              {curNews.map((key, i) =>
                <PostList item={key} index={i} key={i} type='news' type_2='main' heightArr={heightArr} ref={postGroupRef} />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Main;